var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-1920"},[_c('header-user'),_c('store-search'),_c('store-Info-chip'),_c('store-image'),_c('store-menu',{ref:"menu"}),_c('div',{staticClass:"home"},[_c('big-hotsale'),_c('store-recommend')],1),_c('foot'),_c('cart')],1)}
var staticRenderFns = []

export { render, staticRenderFns }